module.exports = __webpack_public_path__ + "img/profile-media.72a05b14.svg";